/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Channel } from './Channel';
import {
    ChannelFromJSON,
    ChannelFromJSONTyped,
    ChannelToJSON,
} from './Channel';
import type { CustomerAttributesMap } from './CustomerAttributesMap';
import {
    CustomerAttributesMapFromJSON,
    CustomerAttributesMapFromJSONTyped,
    CustomerAttributesMapToJSON,
} from './CustomerAttributesMap';
import type { Direction } from './Direction';
import {
    DirectionFromJSON,
    DirectionFromJSONTyped,
    DirectionToJSON,
} from './Direction';
import type { MediaType } from './MediaType';
import {
    MediaTypeFromJSON,
    MediaTypeFromJSONTyped,
    MediaTypeToJSON,
} from './MediaType';

/**
 * 
 * @export
 * @interface TrusstGPTMetadata
 */
export interface TrusstGPTMetadata {
    /**
     * 
     * @type {string}
     * @memberof TrusstGPTMetadata
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof TrusstGPTMetadata
     */
    endTime: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrusstGPTMetadata
     */
    userIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TrusstGPTMetadata
     */
    durationMs: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrusstGPTMetadata
     */
    queueIds: Array<string>;
    /**
     * 
     * @type {Direction}
     * @memberof TrusstGPTMetadata
     */
    initialDirection: Direction;
    /**
     * 
     * @type {MediaType}
     * @memberof TrusstGPTMetadata
     */
    mediaType: MediaType;
    /**
     * 
     * @type {Channel}
     * @memberof TrusstGPTMetadata
     */
    channel: Channel;
    /**
     * 
     * @type {string}
     * @memberof TrusstGPTMetadata
     */
    aniNormalized?: string;
    /**
     * 
     * @type {string}
     * @memberof TrusstGPTMetadata
     */
    dnisNormalized?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrusstGPTMetadata
     */
    wrapupCodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TrusstGPTMetadata
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof TrusstGPTMetadata
     */
    conversationId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrusstGPTMetadata
     */
    previousConversationId?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TrusstGPTMetadata
     */
    recordingId: string;
    /**
     * 
     * @type {string}
     * @memberof TrusstGPTMetadata
     */
    filePath: string;
    /**
     * 
     * @type {CustomerAttributesMap}
     * @memberof TrusstGPTMetadata
     */
    customerAttributes?: CustomerAttributesMap;
}


/**
 * Check if a given object implements the TrusstGPTMetadata interface.
 */
export function instanceOfTrusstGPTMetadata(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "startTime" in value;
    isInstance = isInstance && "endTime" in value;
    isInstance = isInstance && "userIds" in value;
    isInstance = isInstance && "durationMs" in value;
    isInstance = isInstance && "queueIds" in value;
    isInstance = isInstance && "initialDirection" in value;
    isInstance = isInstance && "mediaType" in value;
    isInstance = isInstance && "channel" in value;
    isInstance = isInstance && "organizationId" in value;
    isInstance = isInstance && "conversationId" in value;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "filePath" in value;

    return isInstance;
}

export function TrusstGPTMetadataFromJSON(json: any): TrusstGPTMetadata {
    return TrusstGPTMetadataFromJSONTyped(json, false);
}

export function TrusstGPTMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrusstGPTMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'userIds': json['userIds'],
        'durationMs': json['durationMs'],
        'queueIds': json['queueIds'],
        'initialDirection': DirectionFromJSON(json['initialDirection']),
        'mediaType': MediaTypeFromJSON(json['mediaType']),
        'channel': ChannelFromJSON(json['channel']),
        'aniNormalized': !exists(json, 'aniNormalized') ? undefined : json['aniNormalized'],
        'dnisNormalized': !exists(json, 'dnisNormalized') ? undefined : json['dnisNormalized'],
        'wrapupCodes': !exists(json, 'wrapupCodes') ? undefined : json['wrapupCodes'],
        'organizationId': json['organizationId'],
        'conversationId': json['conversationId'],
        'previousConversationId': !exists(json, 'previousConversationId') ? undefined : json['previousConversationId'],
        'recordingId': json['recordingId'],
        'filePath': json['filePath'],
        'customerAttributes': !exists(json, 'customerAttributes') ? undefined : CustomerAttributesMapFromJSON(json['customerAttributes']),
    };
}

export function TrusstGPTMetadataToJSON(value?: TrusstGPTMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startTime': value.startTime,
        'endTime': value.endTime,
        'userIds': value.userIds,
        'durationMs': value.durationMs,
        'queueIds': value.queueIds,
        'initialDirection': DirectionToJSON(value.initialDirection),
        'mediaType': MediaTypeToJSON(value.mediaType),
        'channel': ChannelToJSON(value.channel),
        'aniNormalized': value.aniNormalized,
        'dnisNormalized': value.dnisNormalized,
        'wrapupCodes': value.wrapupCodes,
        'organizationId': value.organizationId,
        'conversationId': value.conversationId,
        'previousConversationId': value.previousConversationId,
        'recordingId': value.recordingId,
        'filePath': value.filePath,
        'customerAttributes': CustomerAttributesMapToJSON(value.customerAttributes),
    };
}

